import { FadeIn, Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    h: "What we collect",
    body: [
      "When you book a demo class, enquire about a course, or fill a form on our website or through Facebook/Instagram, we may collect: your name, phone number, email address (if provided), and any answers you give us (for example, your trading or coding experience, or your availability for sessions).",
      "If you message us on WhatsApp, we keep that conversation to follow up with you.",
    ],
  },
  {
    h: "How we use it",
    body: [
      "We use this information only to contact you about the course or demo class you enquired about, confirm bookings and payments, and send you relevant updates about batches you've shown interest in. We do not use your information for anything beyond this.",
    ],
  },
  {
    h: "What we don't do",
    body: [
      "We do not sell or rent your information to any third party. We do not share it with anyone except service providers we use to run the business — for example, WhatsApp Business and our payment provider — and only to the extent needed to serve you, or where required by law.",
    ],
  },
  {
    h: "How long we keep it",
    body: [
      "We keep your information for as long as needed to respond to your enquiry or deliver a course you've joined, or until you ask us to delete it.",
    ],
  },
  {
    h: "Your rights",
    body: [
      "You can ask us to show you what information we hold about you, correct it, or delete it, at any time — just message or call us on the number below. This policy is consistent with India's Digital Personal Data Protection Act, 2023.",
    ],
  },
  {
    h: "Contact us",
    body: [
      "Fluenex Academy, 4th Floor, Mangal City Mall, Vijay Nagar, Indore",
      "Phone / WhatsApp: +91 80317 08001",
    ],
  },
  {
    h: "Changes to this policy",
    body: [
      "We may update this page from time to time. Continued use of our services after an update means you accept the revised policy.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page">
      <section className="mesh-wash relative overflow-hidden">
        <div className="blob-decoration w-[460px] h-[460px] bg-violetlight -top-40 -right-32" />
        <div className="w-full mx-auto px-4 md:px-8 lg:px-12 pt-10 md:pt-14 pb-10 md:pb-14 relative">
          <FadeIn>
            <p className="font-sans text-xs font-bold text-terracotta mb-6 uppercase tracking-wide">
              Legal
            </p>
          </FadeIn>
          <h1 className="font-display font-bold tracking-tight text-5xl md:text-7xl leading-[1.0] max-w-4xl text-ink">
            Privacy Policy
          </h1>
          <FadeIn delay={0.4}>
            <p className="font-sans text-lg md:text-xl text-graphite mt-8 max-w-3xl leading-relaxed">
              Fluenex Academy is operated by Fluenex Solutions, Indore. This page explains
              what information we collect from you and how we use it.
            </p>
            <p className="font-sans text-sm font-semibold text-graphite/80 mt-6 uppercase tracking-wide">
              Last updated: 10 September 2026
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="w-full mx-auto px-4 md:px-8 lg:px-12 py-12 md:py-16 pb-24 md:pb-32">
        <div className="max-w-3xl space-y-10 md:space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={(i % 3) * 0.05}>
              <div>
                <h2 className="font-display font-bold tracking-tight text-2xl md:text-3xl text-ink">
                  {s.h}
                </h2>
                <div className="mt-4 space-y-4">
                  {s.body.map((p, j) => (
                    <p key={j} className="font-sans text-base md:text-lg text-graphite leading-relaxed">
                      {p}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
